import React from 'react'
import { StaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

export default function LocationRow () {
  return (
    <StaticQuery query={graphql`
      query LocationsQuery {
        allContentfulCompanyLocation(sort: {fields: createdAt, order: ASC}) {
          edges {
            node {
              locationName
              address {
                json
              }
            }
          }
        }
      }
    `}

      render={ data => (
        <>
          <div className="row mt-5">
              <div className="col-lg-2 col-sm-12">
                  <div className="row d-flex flex-wrap">
          {
              data.allContentfulCompanyLocation.edges.map((item, idx) => {
                return (
                  <React.Fragment key={`content_item_${idx}`}>
                    <div className="col-lg-auto col-sm-4">
                      <address className="text-heading mb-4 address">
                        <p className="h6 text-uppercase font-weight-bold mb-2">{item.node.locationName}</p>
                        {documentToReactComponents(item.node.address.json)}
                      </address>
                    </div>
                  </React.Fragment>
                )
              })
            }
                  </div>
              </div>
              <div className="col-lg-10 col-sm-12">
                  <div width="100%" style={{overflow:'hidden' }}>
                     <iframe src="https://www.google.com/maps/d/embed?mid=1wzyCEA-Vux5jjjtV-acqowOltmlIxdlv" width="100%" height="425px" frameBorder="0" style={{position: 'relative', top: '-54px', border: 'none'}}></iframe>
                  </div>
              </div>
          </div>
        </>
      )}
    />
  )
}